import { Award, Landmark } from 'lucide-react';
import { certifications } from '../mock';

export const CertBadge = ({ cert, dark = false }) => {
  const Icon = cert.icon === 'landmark' ? Landmark : Award;
  return cert.logo ? (
    <img
      src={cert.logo}
      alt={`${cert.name} certification logo`}
      loading="lazy"
      className={`h-full w-full object-contain ${dark && cert.invertOnDark ? 'invert brightness-200' : ''}`}
    />
  ) : (
    <Icon className={`h-6 w-6 ${dark ? 'text-amber-400' : 'text-amber-600'}`} />
  );
};

export default function CertificationsStrip() {
  return (
    <section className="bg-[#0b0b0d] border-y border-white/5 py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-6 md:gap-8">
          {certifications.map((c) => (
            <div key={c.name} className="flex items-center gap-4">
              <div className="h-14 w-14 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center shrink-0 p-2">
                <CertBadge cert={c} dark />
              </div>
              <div>
                <div className="font-display text-lg font-semibold text-white">{c.name}</div>
                <div className="text-xs text-white/50 font-mono uppercase tracking-wider mt-0.5">
                  {c.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
